const AWARDS = [
  {
    id: "most_obedient",
    name: "Most Obedient",
    description: "Awarded for exceptional discipline and reliability.",
    image: "/obedient.png",
  },
  {
    id: "most_positive",
    name: "Most Positive",
    description: "Awarded for spreading positivity and good vibes.",
    image: "/positive.png",
  },
  {
    id: "most_caring",
    name: "Most Caring",
    description: "Awarded for showing great empathy and kindness.",
    image: "/caring.png",
  },
  {
    id: "best_team_player",
    name: "Best Team Player",
    description: "Awarded for outstanding collaboration and support.",
    image: "/helping.png",
  },
  {
    id: "most_innovative",
    name: "Most Innovative",
    description: "Awarded for bringing creative ideas and solutions.",
    image: "/lightbulb.png",
  },
  {
    id: "most_active",
    name: "Most Active",
    description: "Awarded for consistent participation and enthusiasm.",
    image: "/active.png",
  },
];

export default AWARDS;
